import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Button } from "../Button";
import { Loader } from "../Loader";
import { useState } from "react";

export const PaymentForm = ({ onSubmit }: { onSubmit: () => void }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: window.location.href,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (
      (error.type === "card_error" || error.type === "validation_error") &&
      error.message
    ) {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }
    onSubmit();
    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  } as const;

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <h1 className="my-2">Card details</h1>

        <PaymentElement id="payment-element" options={paymentElementOptions} />
        <Button
          btnType="large"
          btnColor="primary"
          className="my-10"
          disabled={isLoading || !stripe || !elements}
          id="submit"
        >
          <span id="button-text">{isLoading ? <Loader /> : "Pay now"}</span>
        </Button>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </form>
    </>
  );
};
